import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Countdown, Avatar } from "components/generic/kit";
import { Overlay, Offer } from "components/generic/layout";
import * as mixpanel from "core/integrations/mixpanel";
import burgerIcon from "../assets/burger.svg";
import arrow from "../assets/down-arrow.svg";

import Menu from "./Menu";

export default ({
  children,
  discount,
  showMenu,
  handleClick,
  isAuthenticated,
  insiders,
  user
}) => (
  <Overlay
    insiders={insiders}
    right={
      user ? (
        <React.Fragment>
          <div
            className="pointer ph2 db-ns flex-ns center-items dn-m dn"
            onClick={handleClick}
          >
            <Name>
              Hi, <span className="b">{user.first_name}</span>
            </Name>
            <img src={arrow} alt="dropdown" className="ml2 mt1" />
          </div>
          <div className="dn-ns db-m db tr pointer" onClick={handleClick}>
            <img src={burgerIcon} alt="open user menu" />
          </div>
        </React.Fragment>
      ) : (
        <Login
          to="/auth/login"
          onClick={() => mixpanel.trackEvent("Sign-in Clicked ")}
        >
          Sign in
        </Login>
      )
    }
  >
    {showMenu && <Menu />}
    {discount.data && (
      <Offer>
        Youve got {discount.data.discount_str} off on your first call if you
        purchase within the next <Countdown time={discount.data.expires_at} />
      </Offer>
    )}
    {children}
  </Overlay>
);

const Login = styled(Link)`
  border-radius: 100px;
  border: 2px solid #000;
  text-decoration: none;
  color: #000000;
  padding: 10px 23px;
`;

const Name = styled.h3`
  font-weight: 400;
  font-family: "CircularStd-Book";
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/Overlay/View.js